// extracted by mini-css-extract-plugin
export var blockedMessage = "_72-3";
export var blockedOverlay = "_72-1";
export var fadeIn = "_72-2";
export var hereLink = "_72-0";
export var slideUp = "_72-4";